import React, { useEffect, useState } from 'react'

function CheckList({ data, checkedItems, onCheckboxChange }) {
  
    return (
      <div>
        <ul className='lyt-check-list'>
          <li className='lyt-check-list__item'>
            {data && data.length > 0 && [...data].sort((a, b) => a.localeCompare(b)).map((item, index) => (
              <div className='bs-checkbox' key={index}>
                <input
                  type="checkbox"
                  id={item}
                  name={item}
                  value={item}
                  checked={checkedItems[item] || false}
                  onChange={() => onCheckboxChange(item)}
                />
                <label className="bs-checkbox__label" htmlFor={item}>{item.toUpperCase()}</label>
              </div>
            ))}
          </li>
        </ul>
      </div>
    );
}

export default CheckList